module.exports = __webpack_public_path__ + "media/campaigns/stashboards_logo_color-6b02649a.png";